// Dependencies
import {
  PROVEEDORES_REQUEST,
  PROVEEDORES_OK,
  PROVEEDORES_REFRESH,
  PROVEEDORES_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchProveedores = () => async (dispatch) => {
  try {
    const response = await get("/proveedores");
    const data = response["data"];
    dispatch({
      type: PROVEEDORES_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: PROVEEDORES_ERROR, payload: error });
    return Promise.reject(error);
  }
};

export const getProveedores = () => (dispatch) => {
  dispatch({ type: PROVEEDORES_REQUEST });
  return dispatch(fetchProveedores());
};
export const refreshProveedores = () => (dispatch) => {
  dispatch({ type: PROVEEDORES_REFRESH });
  return dispatch(fetchProveedores());
};
